import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { useAuth } from '@restworld/feature-authentication';

export const useProfileCommonIntl = () => {
  const { t } = useTranslation();
  const { user } = useAuth();

  const welcomeToSectorText = `${t('onboarding-page:welcome_to_sector_1')} ${user.name}! ${t(
    'onboarding-page:welcome_to_sector_2'
  )}`;

  return useMemo(
    () => ({
      missingInfoText: t('onboarding-page:missing_info_fill_fields'),
      certificate: t('common:certificate'),
      missingInfo: t('common:missing_info'),
      noExperienceText: t('onboarding-page:i_have_no_experience'),
      welcomeToSectorText,
      translate: t,
    }),
    [t, welcomeToSectorText]
  );
};
